import React from 'react';

import { Alert, AlertType } from 'components/lds';

import { M } from 'components/typography';

export const InfoMessage = ({ message }: { message: string }) => (
  <Alert type={AlertType.info}>
    <M>{message}</M>
  </Alert>
);
